<template>
  <v-main>
    <v-layout>
      <router-view />
    </v-layout>
  </v-main>
</template>

<script>
export default {
  name: 'AppCoreView',
}
</script>
